import { DpBenefits } from '@/components/blocks/Benefits';
import { ID } from '@/data/types/Basic';
import { FC } from 'react';

export const ContentBenefits: FC<{ id: ID }> = () => (
	<DpBenefits />
);
